module.exports = __webpack_public_path__ + "static/media/logo.27aa0ad2.png";